import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Link } from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  image: {
    maxWidth: '100%',
    borderRadius: theme.shape.borderRadius,
  },
  body: {
    '& p': {
      marginTop: 0,
    },
    '& ul': {
      marginTop: 0,
      paddingLeft: theme.spacing(3),
    },
  },
}));

// Use this as title to hide the news widget
// const NO_NEWS_TITLE = '';

/**
 * Edit the content below to update the news widget on the home page.
 * Supports text (paragraphs), links, and images.
 * Comment in const NO_NEWS_TITLE = ''; and set NEWS_WIDGET_TITLE to NO_NEWS_TITLE to hide the widget entirely.
 */
const NO_NEWS_TITLE = '';
export const NEWS_WIDGET_TITLE = NO_NEWS_TITLE;
export const NewsWidget = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="body1" className={classes.body}>
        <p>We're testing out two new features and want your feedback:</p>
        <ul>
          <li>
            <strong>Codespaces</strong> —{' '}
            <Link to="/catalog/default/Template/create-codespace-repo">create</Link> one, then
            manage them from the <Link to="/github-codespaces">Codespaces</Link> menu.
          </li>
          <li>
            <strong>Azure templates</strong> — <Link to="/create">create</Link> resource groups, Key
            Vaults and PostgreSQL servers.
          </li>
        </ul>
        <p>
          What do you think? Or do you have any other ideas? Reach out to us in the{' '}
          <Link to="https://equinor.enterprise.slack.com/archives/C092FT0AADN">
            #varia Slack channel
          </Link>
          .
        </p>
      </Typography>
    </div>
  );
};
